export default "<div #dest></div>\n<div id=\"{{SCREEN_ID + '_' + pageNo}}\"></div>\n<div id=\"gaid\"></div>\n<app-wait-modal #waitModal></app-wait-modal>";